import React from 'react'
import { useState } from 'react'
import Cropper from 'react-easy-crop'

export default function Cropimage() {
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(5)
    const [image, setImage] = useState(null)


    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        console.log(croppedArea, croppedAreaPixels)
    }
    const changeimage = (e) => {
        console.log(e);

    }
    return (
        <div>
            <input type="file" name='image' onChange={(e) => setImage(URL.createObjectURL(e.target.files[0]))} />
            <hr />
            {image != null ? <>
                <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    aspect={20 / 10}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                >

                </Cropper>
            </> : ''}
        </div>
    )
}
